import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";
import AdminDashbooard from "@/views/AdminDashbooard.vue";
import AdminHome from "@/views/DashboardContent/AdminHome.vue";
import EnrollmentsView from "@/views/DashboardContent/EnrollmentsView.vue";
import VideoLessons from "@/views/DashboardContent/VideoLessons.vue";
import StudentsView from "@/views/DashboardContent/StudentsView.vue";
import PaymentView from "@/views/DashboardContent/PaymentView.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/about",
    name: "about",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
  },

  {
    path: "/adminDashboard",
    name: "adminDashboard",
    component: AdminDashbooard,
    meta: { requiresAuth: true },
  },
  {
    path: "/home",
    name: "adminHome",
    component: AdminHome,
  },

  {
    path: "/enrollments",
    name: "enrollments",
    component: EnrollmentsView,
  },

  {
    path: "/videosLessons",
    name: "videosLessons",
    component: VideoLessons,
  },

  {
    path: "/students",
    name: "studentView",
    component: StudentsView,
  },
  {
    path: "/payments",
    name: "paymentView",
    component: PaymentView,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

// Global navigation guard
// router.beforeEach((to, from, next) => {
//   const token = localStorage.getItem("token"); // use token instead of sessionStorage

//   if (to.meta.requiresAuth && !token) {
//     // Not logged in → redirect to homepage
//     next({ path: "/" });
//   } else {
//     next();
//   }
// });
export default router;
